import React from 'react';
import { defineMessages, t } from '@sm/intl';
import PropTypes from 'prop-types';

import SimpleLogoHeader from '~app/components/SimpleLogoHeader';
import SimpleHero from '~app/components/SimpleHero';
import HeroFormCallout from '~app/components/HeroFormCallout';
import FortuneCallout from '~app/components/FortuneCallout';
import ProductsCalloutList from '~app/components/ProductsCalloutList';

const COPY = defineMessages({
  HERO_FORM_CALLOUT_BOLD_HEADER: {
    id: 'RebrandEpFormCore.HeroFormCalloutBoldHeader',
    defaultMessage: 'Want to create your own surveys?',
    description:
      "[Type: Header][Vis: high] - The Hero's Primary tagline. A question to put into context the subheader beneath this tagline, and to entice users to fillout and submit the form directly below the header.",
  },
  HERO_FORM_CALLOUT_SUBHEADER: {
    id: 'RebrandEpFormCore.HeroFormCalloutSubHeader',
    defaultMessage:
      'Gather opinions from customers, employees, prospects, and more. Use your insights to make better, data-driven decisions.',
    description:
      "[Type: Header][Vis: high] - The Hero's subheader. A value proposition, giving a clear example of what they can get if they fill out the form below.",
  },
  HERO_FORM_CTA_COPY: {
    id: 'RebrandEpFormCore.HeroFormCTACopy',
    defaultMessage: 'Sign up free',
    description: '[Type: Label][Vis: high] - The copy for the main endpage CTA to encourage user sign ups.',
  },

  FORTUNE_CALLOUT_COPY: {
    id: 'RebrandEpFormCore.FortuneCalloutCopy',
    defaultMessage: '95% of the Fortune 500 rely on SurveyMonkey for People Powered Data',
    description: '[Type: Header][Vis: low] - A promotional statistic designed to show corporate trust and prestige',
  },
  FORTUNE_CALLOUT_CTA: {
    id: 'RebrandEpFormCore.FortuneCalloutCTA',
    defaultMessage: 'SIGN UP FREE',
    description: "[Type: Button][Vis: high] - Fortune's CTA which sends people to a sign up page",
  },
});

const RebrandEpFormCore = ({ utSource, calloutItem1, calloutItem2, hideCTAs }) => {
  const HERO_FORM_CTA = {
    ctaFormCopy: t(COPY.HERO_FORM_CTA_COPY),
    utSource,
    utSource2: 'rebrand_ep_form',
  };

  return (
    <>
      <Choose>
        <When condition={hideCTAs}>
          <SimpleHero />
          <ProductsCalloutList calloutItem1={calloutItem1} calloutItem2={calloutItem2} utSource={utSource} hideCTAs />
          <FortuneCallout
            copy={t(COPY.FORTUNE_CALLOUT_COPY)}
            ctaText={t(COPY.FORTUNE_CALLOUT_CTA)}
            utSource={utSource}
            utSource2="rebrand_ep_form"
            hideCTAs
          />
        </When>
        <Otherwise>
          <SimpleLogoHeader />
          <HeroFormCallout
            boldHeader={t(COPY.HERO_FORM_CALLOUT_BOLD_HEADER)}
            subHeader={t(COPY.HERO_FORM_CALLOUT_SUBHEADER)}
            formCopy={HERO_FORM_CTA}
          />
          <ProductsCalloutList calloutItem1={calloutItem1} calloutItem2={calloutItem2} utSource={utSource} />
          <FortuneCallout
            copy={t(COPY.FORTUNE_CALLOUT_COPY)}
            ctaText={t(COPY.FORTUNE_CALLOUT_CTA)}
            utSource={utSource}
            utSource2="rebrand_ep_form"
          />
        </Otherwise>
      </Choose>
    </>
  );
};

RebrandEpFormCore.propTypes = {
  utSource: PropTypes.string.isRequired,
  calloutItem1: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    ctaColor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  calloutItem2: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    ctaColor: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  hideCTAs: PropTypes.bool,
};

RebrandEpFormCore.defaultProps = {
  hideCTAs: false,
};

export default RebrandEpFormCore;
